var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystrategyCubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M 31.847 16.309 L 46.047 41.009 C 47.047 42.709 48.847 43.709 50.747 43.709 L 79.247 43.709 C 80.947 43.709 82.047 41.909 81.147 40.409 L 66.947 15.609 C 65.947 13.909 64.147 12.909 62.247 12.909 L 33.847 12.909 C 32.147 12.909 31.047 14.809 31.847 16.309 Z",
    style: {
      fill: "rgb(83, 106, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 28.596 16.782 L 42.496 40.782 C 43.396 42.282 42.296 44.082 40.596 44.082 L 12.796 44.082 C 11.096 44.082 9.996 42.282 10.896 40.782 L 24.796 16.782 C 25.596 15.282 27.696 15.282 28.596 16.782 Z",
    style: {
      fill: "rgb(130, 142, 193)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 12.618 46.997 L 40.518 46.997 C 42.218 46.997 43.218 48.797 42.418 50.297 L 28.518 74.397 C 27.718 75.897 25.618 75.897 24.718 74.397 L 10.718 50.297 C 9.918 48.797 11.018 46.997 12.618 46.997 Z",
    style: {
      fill: "rgb(184, 190, 221)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M 66.733 74.662 L 81.033 49.962 C 81.833 48.462 80.833 46.662 79.133 46.662 L 50.533 46.662 C 48.633 46.662 46.833 47.662 45.833 49.362 L 31.533 74.162 C 30.733 75.662 31.733 77.462 33.433 77.462 L 61.933 77.462 C 63.933 77.362 65.733 76.362 66.733 74.662 Z",
    style: {
      fill: "rgb(23, 77, 152)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystrategyCubeLogo);
export default __webpack_public_path__ + "static/media/systrategy_cube_logo.1adcdd80210d9e666e96b54c5a5fde88.svg";
export { ForwardRef as ReactComponent };